<template>
  <div class="main">
    <back title="推荐就业"></back>
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/banner/jobs-banner.jpg"
    ></landingBanner>
    <div class="content">
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/jobs/part1.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle title1="六重就业扶持" title2="Six Job Security"></indexTitle>
      <tab2></tab2>
      <find></find>
      <indexTitle title1="就业指导“三步法”" title2="Service Guidance"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/jobs/part2.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <find></find>
      <indexTitle title1="技能+学历双提升" title2="Double promotion of skills+education"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/jobs/part5.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle title1="校企合作" title2="School Enterprise Cooperation"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/jobs/part3.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <find></find>
      <indexTitle title1="优秀学子与你同行" title2="Excellent Students Go With You"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/jobs/part4-1.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/jobs/part4-2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <indexTitle title1="选择课程，了解学费" title2="校企合作，定向委托"></indexTitle>
      <footerForm color="#fff" bag="#a96b04" words="点击获取学费报价"></footerForm>
    </div>
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {
    back: () => import("../../../components/head/back"),
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    tab2: () => import("@/components/common/tab2"),
    indexTitle: () => import("@/components/common/indexTitle"),
    find: () => import("@/components/common/find"),
    footerForm: () => import("@/components/form/footerForm")
  },
  mothods() {}
};
</script>
<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.main {
  margin-top: 50px;
}

.content {
  padding: 10px;
}
</style>
